import React, { useState, useContext } from "react";
import { AppContext } from "../../components/States/AppContext";
import { Link } from "react-router-dom";

// components
import TopBar from "../../components/MonitorComponents/TopBar";
import MessageBox from "../../components/MonitorComponents/MessageBox";
import PatientDemo from "../../components/MonitorComponents/PatientDemo";

// styles
import { LandScapeContainer } from "./LandScapePage.elements";
import {
  SettingsTopLine,
  SettingsBack1,
  SettingsClose,
} from "../../components/Settings/SettingBar.elements";
import {
  ArrowItem,
  ChartContainer,
  ChartImg,
  GraphContainer,
  GraphImg,
  TabContainer,
  TabItem,
  TabLink,
  TabLinkDiv,
  TimeBoxDate,
} from "./Trends.elements";

// icons && images
import { AiOutlineClose } from "react-icons/ai";
import {
  MdOutlineArrowBackIosNew,
  MdOutlineArrowForwardIos,
} from "react-icons/md";
import graphtrend from "../../img/trends/graphtrend copy.png";


//data removed 7.19 and put trends data in stead instead. keep here in case any issues come up


const Trends = () => {
  const { state, setState } = useContext(AppContext);
  const [tabs, setTabs] = useState(state.trends[0]);

  const activeIndex = tabs.tabs.findIndex((tab) => tab.active);
  const isBackDisabled = activeIndex === 0;
  const isForwardDisabled = activeIndex === tabs.tabs.length - 1;

  const handleBackClick = () => {
    setTabs((prevTabs) => {
      const activeIndex = prevTabs.tabs.findIndex((tab) => tab.active);
      const prevIndex =
        activeIndex === 0 ? prevTabs.tabs.length - 1 : activeIndex - 1;
      return {
        ...prevTabs,
        tabs: prevTabs.tabs.map((tab, index) => {
          return {
            ...tab,
            active: index === prevIndex,
          };
        }),
      };
    });
  };

  const handleForwardClick = () => {
    setTabs((prevTabs) => {
      const activeIndex = prevTabs.tabs.findIndex((tab) => tab.active);
      const nextIndex =
        activeIndex === prevTabs.tabs.length - 1 ? 0 : activeIndex + 1;
      return {
        ...prevTabs,
        tabs: prevTabs.tabs.map((tab, index) => {
          return {
            ...tab,
            active: index === nextIndex,
          };
        }),
      };
    });
  };

  const handleClick = (index) => {
    setTabs((prevTabs) => {
      const newTabs = prevTabs.tabs.map((tab, i) => {
        return {
          ...tab,
          active: i === index,
        };
      });
      return { ...prevTabs, tabs: newTabs };
    });
  };

  const tabButtons = tabs.tabs.map((time, index) => {
    return (
      <TabItem
        active={time.active}
        key={time.id}
        onClick={() => handleClick(index)}
      >
        {time.time}
      </TabItem>
    );
  });

  const activeChart = tabs.tabs
    .filter((time) => time.active === true)
    .map((time) => <ChartImg src={time.chart} key={time.id} />);

  function handleBackButtonClick() {
    const scrollPosition = window.pageYOffset;
    window.history.back();
    setTimeout(() => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          window.scrollTo(0, element.offsetTop);
        }
      } else {
        window.scrollTo(0, scrollPosition);
      }
    }, 0);
  }

  const currentTime = new Date();

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const month = months[currentTime.getMonth()];
  const day = currentTime.getDate();

  const formattedDate = `${month} ${day}`;

  return (
    <LandScapeContainer>
      <TopBar />
      <MessageBox landscape />
      <PatientDemo />
      <SettingsTopLine>
        {state.trendsType} : {state.trendsSetting}
        <SettingsBack1 onClick={handleBackButtonClick}>
          <MdOutlineArrowBackIosNew></MdOutlineArrowBackIosNew>
        </SettingsBack1>
        <Link to="/">
          <SettingsClose>
            <AiOutlineClose></AiOutlineClose>
          </SettingsClose>
        </Link>
      </SettingsTopLine>

      <ChartContainer>
        <TimeBoxDate>{formattedDate}</TimeBoxDate>
        {activeChart}
        <TabLink to="/trendsmenu">
          <TabLinkDiv></TabLinkDiv>
        </TabLink>

        {state.trendsType === "Graph Trend" && (
          <>
            <GraphContainer>
              <GraphImg src={graphtrend} />
            </GraphContainer>
          </>
        )}
      </ChartContainer>

      <TabContainer>
        {tabButtons}
        <ArrowItem onClick={handleBackClick} disabled={isBackDisabled}>
          {isBackDisabled ? (
            <MdOutlineArrowBackIosNew style={{ color: "gray" }} />
          ) : (
            <MdOutlineArrowBackIosNew />
          )}
        </ArrowItem>
        <ArrowItem onClick={handleForwardClick} disabled={isForwardDisabled}>
          {isForwardDisabled ? (
            <MdOutlineArrowForwardIos style={{ color: "gray" }} />
          ) : (
            <MdOutlineArrowForwardIos />
          )}
        </ArrowItem>
      </TabContainer>
    </LandScapeContainer>
  );
};

export default Trends;
